import React, { useCallback, useEffect, useState } from 'react';

import { Input } from '@mesh.ai/rabbit';
import { AgGridReact } from 'ag-grid-react';

interface Props {
  gridRef: React.RefObject<AgGridReact>;
  placeholder?: string;
  cohortId?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const AgGridSearch = ({ gridRef, placeholder = '', cohortId, inputProps = {} }: Props) => {
  const [searchText, setSearchText] = useState('');

  const handleTextChange = useCallback((e) => {
    const updatedText = e.target.value;
    setSearchText(updatedText);
  }, []);

  useEffect(() => {
    if (searchText !== null && gridRef?.current?.api) {
      gridRef?.current?.api?.setGridOption('quickFilterText', searchText);
    }
  }, [gridRef, searchText]);

  // not an ideal method
  useEffect(() => {
    setSearchText('');
  }, [cohortId]);

  return (
    <Input
      placeholder={placeholder}
      onChange={handleTextChange}
      value={searchText}
      style={{
        maxWidth: '360px',
        minWidth: '180px',
        marginRight: '16px',
        ...inputProps,
      }}
      type="search"
    />
  );
};

export { AgGridSearch };
